const host = window.location.host;
const path = window.location.pathname;
let authorize = process.env.NODE_ENV === 'production' && host.indexOf('staging') == -1 && host.indexOf('test') == -1 && host.indexOf('dev') == -1;
let portal = host.indexOf('localhost') != -1 || path.indexOf('/portal') != -1;

const staging = host.indexOf('staging') >= 0;

let phone = false;
let messages = false;
let messages_se = false;
let gronlinje = false;
let statistics = false;

let locale = host.indexOf('diedahus') == -1 ? 'nb' : 'se';

// telefon.kirkens-sos.no
if (host.indexOf('telefon.') >= 0) {
    phone = true;
    // stat.kirkens-sos.no
} else if (host.indexOf('stat.') >= 0) {
    statistics = true;
    // gronnlinje.kirkens-sos.no
} else if (host.indexOf('gronnlinje.') >= 0) {
    statistics = true;
    authorize = false;
} else if (host.indexOf('diedahus.') >= 0) {
    messages = true;
    messages_se = true;
    // dev
} else if (host.indexOf('dev') >= 0 || host.indexOf('localhost') >= 0) {
    const query = new URLSearchParams(window.location.search);
    const app = query.get('app');
    switch (app) {
        case 'message':
        case 'messages':
            messages = true;
            break;

        case 'phone':
            phone = true;
            break;
        default:
            messages = true;
        //messages_se = true;
        //locale = 'se';
    }
}
// default
else {
    messages = true;
}

export const config = {
    environment: {
        development: {
            api_url: 'https://services.kirkens-sos.lndo.site/api',
            phone_chat_url: 'ws://localhost:8090/volunteer/chat',
        },
        production: {
            api_uri: '/frivillig/api',
            phone_chat_url: staging ? 'wss://telefon.staging.kirkens-sos.no/portal/chat' : 'wss://telefon.kirkens-sos.no/portal/chat',
            base: '/portal/',
        },
    },

    localeApp: locale,
    locale: 'nb',

    portal: portal,

    components: {
        app: 'App.vue',
    },

    authorize: authorize
        ? {
              secret: 'MRsos',
              cookie: 'sosmessages-authorization',
              ci_cookie: 'authorization',
              expores: 365,
          }
        : null,

    app: {
        phone: phone,
        messages: messages,
        messages_se: messages_se,
        gronlinje: gronlinje,
        statistics: statistics,
    },
    routes: {
        default: !!messages,
        local: true,
    },
    hasDrawer: messages,
    logo: require('./../img/logo.svg'),

    messages: {
        dueHours: 24,
        answerDueHours: 4,
        unlockDrafts: false,
        closeMessage: false,
        approve: false,
        sentRole: new RegExp('administrator'),
        callersRole: new RegExp('administrator'),
    },

    centers: true,
    userDetails: false,
    callerDetails: false,

    reply: {
        comments: false,
    },

    themes: {
        light: {
            primary: '#31285b',
            secondary: '#004053',
            accent: '#31285b',
            info: '#000000',
        },
    },
};



//////////////////
// WEBPACK FOOTER
// ./volunteer/config/config.js
// module id = null
// module chunks = 